import { PushNotifications } from "@capacitor/push-notifications";
import { saveToStorage } from "../utils/Helper";
import { StorageConstants } from "../constants/Constants";
import { LocalNotifications } from "@capacitor/local-notifications";
import { App } from "@capacitor/app";
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from "@capacitor/core";


export const isAppForeground = async () => {
    const state = await App.getState();
    return state.isActive;
};

export const initializeNativePush = async () => {
    console.log("📱 Initializing native push notifications...");

    // Request permission
    const permission = await PushNotifications.requestPermissions();
    if (permission.receive !== "granted") {
        console.warn("Permission not granted for native push notifications");
        return;
    }

    // Register device
    await PushNotifications.register();

    // Token received
    PushNotifications.addListener("registration", (token) => {
        console.log("✅ Native FCM Token:", token.value);
        saveToStorage({ key: StorageConstants?.FCM_TOKEN, value: token.value })
        // Send this token to your backend
    });

    if (Capacitor.getPlatform() == 'ios') {
        const token = await FirebaseMessaging.getToken();
        console.log("✅ Native IOS FCM Token:", token);
        saveToStorage({ key: StorageConstants?.FCM_TOKEN, value: token.token })
    }

    // Registration error
    PushNotifications.addListener("registrationError", (error) => {
        console.error("❌ Registration error:", error);
    });

    // Notification received in foreground
    PushNotifications.addListener("pushNotificationReceived", async (notification) => {
        console.log("📩 Push received:", notification);
        const isForeground = await isAppForeground();

        const isAndroid = Capacitor.getPlatform() === "android";

        // Avoid double notifications on Android
        const autoShownBySystem = isAndroid && (notification.title || notification.body);

        if (isForeground && !autoShownBySystem) {
            await LocalNotifications.schedule({
                notifications: [
                    {
                        title: notification.data?.title ?? 'Notification',
                        body: notification.data?.body ?? 'New message',
                        id: Date.now(),
                    }
                ]
            });
        }
    });

    // User taps on notification
    PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
        console.log("🖱️ Notification action:", action.notification);
    });
};
